import DomainFeaturePopup from './DomainFeaturePopup';

export default DomainFeaturePopup;
